import { createAction } from '@reduxjs/toolkit'

import { AdditionalSegment } from 'types/GlobalAdditionalSegment'

// tryCreateAdditionalSegmentBy
export const create = createAction('create_addditional_segment')
export const createSuccess = createAction<AdditionalSegment>(
  'create_addditional_segment_success'
)
export const createFailed = createAction('create_addditional_segment_failed')

// tryUpdateAdditionalSegmentBy
export const update = createAction('update_addditional_segment')
export const updateSuccess = createAction<AdditionalSegment>(
  'update_addditional_segment_success'
)
export const updateFailed = createAction('update_addditional_segment_failed')

// tryDeleteAdditionalSegmentBy
export const destroy = createAction('delete_addditional_segment')
export const destroySuccess = createAction<{
  id: string
  widgetId: string
}>('delete_addditional_segment_success')
export const destroyFailed = createAction('delete_addditional_segment_failed')
